import { render } from "./NewsletterSignupBlock.vue?vue&type=template&id=283863bc&scoped=true"
import script from "./NewsletterSignupBlock.vue?vue&type=script&lang=js"
export * from "./NewsletterSignupBlock.vue?vue&type=script&lang=js"

import "./NewsletterSignupBlock.vue?vue&type=style&index=0&id=283863bc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283863bc"]])

export default __exports__